<template>
<div class="reportEdit padding-20 bgc box-shadow">
    <div class="message" v-if="!realName">
        <el-alert title="" type="warning" show-icon :closable="false">请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容。</el-alert>
    </div>
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="formName" label-width="120px" class="demo-item" label-position="left" size="mini">
            <div class="classes blod">基本信息</div>
            <el-form-item label="报告年份" prop="reportyear">
                <el-date-picker v-model.trim="item.reportyear" type="year" format="yyyy" value-format="yyyy"></el-date-picker>
            </el-form-item>
            <el-form-item label="报告名称" prop="reportname" class="reportname">
                <el-input placeholder="请输入您要上传的报告标题，不超过100字。" v-model.trim="item.reportname" clearable maxlength="100" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="报告封面" class="upload-image" prop="coverPicture">
                <upload class="headImage" v-model="item.imageinfo.furl" :imgRule="imgRule" @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                <div class="el-upload__tip">
                    <el-button type="warning" @click="opencoverScrollBox">素材库</el-button>
                    <div>1.建议上传尺寸750*420px，jpg或png格式，不超过2M </div>
                    <div>2.精美封面有助于增加浏览量，并有机会获得强力推荐！</div>
                </div>
            </el-form-item>
            <el-form-item label="报告下载" required>
                <el-switch v-model="item.isdownload"></el-switch>
            </el-form-item>
            <el-form-item label="报告分类" prop="nodes" required>
                <el-cascader expand-trigger="hover" placeholder="请选择分类" :options="industryList" v-model="item.nodes" :show-all-levels="false"> </el-cascader>
            </el-form-item>
            <el-form-item label="报告标签" class="reportLabel">
                <el-input v-model.trim="item.reptagsname" placeholder="多个标签请用逗号隔开" clearable></el-input>
            </el-form-item>
            <el-form-item label="资鲸会员类型" v-if="user.iszjhost" class="reportLabel">
                <el-select v-model="item.zjmemtype">
                    <el-option :label="item.label" :value="item.value" v-for="(item, index) in zjmemtype" :key="index"></el-option>
                </el-select>
                <!-- <el-radio-group v-model="item.zjmemtype">
                    <el-radio :label="1">支持</el-radio>
                    <el-radio :label="0">不支持</el-radio>
                </el-radio-group> -->
            </el-form-item>
            <el-form-item label="上传文件" prop="pdfinfo" required class="uploadFileBox">
                <div class="pdfMsg" v-if="item.pdfinfo.furl">
                    <span class="fname">{{item.pdfinfo.fname}}</span><span>{{fsize(item.pdfinfo.fsize)}}</span><span class="delPdf" @click="delPdf">删除</span>
                </div>
                <div class="upload-pdf">
                    <uploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
                </div>
            </el-form-item>
            <el-form-item label="报告目录" class="reportCatalog">
                <el-input v-model.trim="item.repdirectory" type="textarea" :rows="6"></el-input>
            </el-form-item>
            <el-form-item label="报告简介">
                <uEditor :content="item.repintro" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
            </el-form-item>
            <el-form-item label="试读设置" label-width="120px" class="form-5" prop="tryRead">
                <el-radio-group v-model="item.ispreview">
                    <el-radio :label="'1'">支持试读至<el-input v-model="item.previewpages"></el-input>页</el-radio>
                    <el-radio :label="'0'">不支持试读</el-radio>
                </el-radio-group>
                <div class="ispreview-tip">
                    <div><span class="ii"></span><i class="icon icon_warning"></i>免费报告若设置支持试读会默认开启“分享解锁”功能</div>
                    <div><i class="icon icon_warning"></i>若试读页数超过文件页数，用户将免费查看，请检查页数是否设置合理。</div>
                </div>
            </el-form-item>
            <div class="classes blod">商品信息</div>
            <el-form-item label="售卖方式">
                <promotionMsg ref="promotionMsg" @changeWay="changeWay" :tryRead="item.ispreview" :zjmemtype="item.zjmemtype"></promotionMsg>
            </el-form-item>
            <!-- <el-form-item label="商品分组" class="commodityGroup" v-if="domain === 1"> -->
            <el-form-item label="商品分组" class="commodityGroup">
                <el-select v-model="item.divisionids" multiple placeholder="请选择" collapse-tags clearable>
                    <el-option v-for="item in shopGroupList" :key="item.innerid" :label="item.name" :value="item.innerid"> </el-option>
                </el-select>
                <el-button type="text" size="small" @click="_getShopGroupList">刷新</el-button>
                <el-button type="text" size="small" @click="goGoodsGroup">前往商品分组</el-button>
                <p class="groupTips">商品分组可辅助你更好地管理商品</p>
            </el-form-item>
            <div class="classes blod">上架设置</div>
            <el-form-item label="上架方式" prop="onLineType" class="onlineWay">
                <!--<el-radio :label="1" v-model="item.onlinetype">立即上架</el-radio><br>-->
                <!--<el-radio :label="2" v-model="item.onlinetype">定时上架</el-radio>-->
                <!--<el-date-picker placeholder='请选择定时上架时间' v-model.trim="item.onlinetime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="String(item.onlinetype) !== '2'"  type="datetime"></el-date-picker><br/>-->
                <!--<el-radio :label="3" v-model="item.onlinetype">暂不上架</el-radio>-->
                <shalfSetting ref="shalfSetting" :item="item"></shalfSetting>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('item')" :disabled="submitBtn">提交</el-button>
                <el-button type="" @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
    <scrollBox ref="coverScrollBox" :uploadType="uploadType" @saveMaterialFile="setMaterialCoverfile"></scrollBox>
    <!-- <gallery ref="gallery" @setImage="setImage"></gallery> -->
</div>
</template>

<script>
import Upload from 'base/upload/upload'
import UploadFile from 'base/upload/uploadFile'
import UEditor from 'base/uEditor/uEditor'
// import Gallery from './Gallery'
import ScrollBox from '@/base/scrollBox/scrollBox'
import PromotionMsg from 'base/promotionMsg/promotionMsg'
import {reportMgtCode} from 'api/enumCode'
import {mapGetters, mapActions} from 'vuex'
import {formatCheckView, formatCheckList, formatFileInfo, computeFileSize} from 'common/js/tools'
import {getReportIndustryList, getReportView, editReport, addReport, getShopGroupList} from 'api/api'
import ShalfSetting from 'base/promotionMsg/shalfSetting'
import $ from 'jquery'
export default {
    name: 'reportEdit',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            if (!this.item.imageinfo.furl) {
                callback(new Error('请选择报告封面'))
            } else {
                callback()
            }
        }
        let validatePdfInfo = (rule, value, callback) => {
            if (!this.item.pdfinfo.furl) {
                callback(new Error('请上传PDF文件'))
            } else {
                callback()
            }
        }
        let checkTryRead = (rule, value, callback) => {
            if (this.item.ispreview === '1') {
                if (!this.item.previewpages) {
                    callback(new Error('请输入试读页数'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        let checkNodes = (rule, value, callback) => {
            if (!this.item.nodes.length) {
                callback(new Error('请选择报告分类'))
            } else {
                callback()
            }
        }
        let checkOnlineType = (rule, value, callback) => {
            if (this.item.onlinetype === 2) {
                if (!this.item.onlinetime) {
                    callback(new Error('请选择上架时间'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        return {
            onlinetypeList: reportMgtCode.onlinetype,
            feetypeList: reportMgtCode.feetype,
            industryList: [], // 行业列表
            shopGroupList: [], // 商品分组
            realName: false,
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            },
            uploadVideoType: {
                catecode: '94',
                datatype: 'FILE'
            },
            zjmemtype: [
                {label: '不支持', value: 0},
                {label: 'PLUS卡', value: 1},
                {label: '年卡', value: 2}
            ],
            item: {
                innerid: this.$route.query.id ? this.$route.query.id : '', // id
                reportyear: '2019', // 报告年份
                reportname: '', // 报告名称
                reptagsname: '', // 报告标签
                nodes: [], // 行业分类id
                imageinfo: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }, // 报告封面
                isdownload: false, // 是否允许下载：0否 1是
                pdfinfo: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    key: '',
                    mimeType: '',
                    furl: ''
                }, // pdf
                repdirectory: '', // 报告目录
                repintro: '', // 报告简介
                ispreview: '0', // 是否支持试读 免费报告若设置不支持试读会默认开启“分享解锁”功能
                previewpages: '', // 试读页数
                onlinetype: 1, // 上架方式1：表示直接上架 2：表示定时上架
                onlinetime: '', // 上架时间
                divisionids: [],
                isplatform: true,
                ispublic: true,
                zjmemtype: 0
            },
            feetype: 1,
            submitBtn: false,
            rules: {
                reportyear: [
                    {required: true, message: '请选择报告年份', trigger: 'blur'}
                ],
                reportname: [
                    {required: true, message: '请选择报告名称', trigger: 'blur'},
                    {min: 3, max: 100, message: '长度在3到100个字符', trigger: 'blur'}
                ],
                nodes: [
                    {validator: checkNodes, trigger: 'blur'}
                ],
                pdfinfo: [
                    {validator: validatePdfInfo, trigger: 'blur'}
                ],
                coverPicture: [
                    {validator: validateCoverPicture, trigger: 'change'}
                ],
                onlinetype: [
                    {required: true, message: '请选择上架方式', trigger: 'blur'},
                    {validator: checkOnlineType, trigger: 'blur'}
                ],
                tryRead: [
                    {validator: checkTryRead, trigger: 'blur'}
                ]
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: 100,
                height: 100
            },
            fileRule: {
                btnName: '上传附件...',
                cls: '',
                accept: 'application/pdf',
                size: 10,
                width: '',
                height: ''
            }
        }
    },
    created() {
        // 获取当前年份
        let year = new Date()
        this.item.reportyear = String(year.getFullYear())
    },
    mounted() {
        this._getReportIndustryList()
        this._getShopGroupList()
        if (this.item.innerid) {
            this._getView()
        }
    },
    methods: {
        // 打开图片素材库选择框
        opencoverScrollBox () {
            this.$refs.coverScrollBox.openDialog()
        },
        // 设置素材库选择的图片信息（封面）
        setMaterialCoverfile (file) {
            this.item.imageinfo = file
            this.$refs.coverfile.setImage(this.item.imageinfo.furl)
        },
        setCoverfile (file) {
            this.item.imageinfo = file
        },
        setFile(file) {
            computeFileSize()
            this.item.pdfinfo = file
        },
        handleOpenGallery() {
            this.$refs.gallery.openDialog(this.item)
        },
        getUEditorContent(content) {
            this.item.repintro = content
        },
        submitForm() {
            let shalfSetting = this.$refs.shalfSetting.checkShalfSetting()
            this.$refs.promotionMsg.$refs.sellWayForm.validate((v) => {
                this.$refs.formName.validate((valid) => {
                    if (v && valid && shalfSetting) {
                        this.submitBtn = true
                        this.$confirm('请确认您的输入信息是否完整正确？', '提交内容', {
                            cancelButtonText: '取消',
                            confirmButtonText: '确定',
                            closeOnClickModal: false
                        }).then(() => {
                            let tmpList = formatCheckList(JSON.parse(JSON.stringify(this.$refs.promotionMsg.item.checkView)))
                            let obj = $.extend(true, {}, Object.assign({}, this.item, this.$refs.promotionMsg.item))
                            obj.checkView = JSON.stringify(tmpList)
                            obj.imageinfo.furl = obj.imageinfo.furl.split('?')[0]
                            obj.imageinfo = formatFileInfo(obj.imageinfo)
                            obj.pdfinfo.furl = obj.pdfinfo.furl.split('?')[0]
                            obj.pdfinfo = formatFileInfo(obj.pdfinfo)
                            obj.isdownload = obj.isdownload ? 1 : 0
                            obj.isplatform = obj.isplatform ? 1 : 0
                            obj.ispublic = obj.ispublic ? 1 : 0
                            if (obj.divisionids.length) {
                                obj.divisionids = obj.divisionids.join(',')
                            }
                            obj.nodes = obj.nodes.join(',')
                            if (obj.innerid) {
                                this._editObject(obj)
                            } else {
                                this._addObject(obj)
                            }
                        }).catch(() => {
                            this.submitBtn = false
                        })
                    } else {
                        this.submitBtn = false
                        this.$message.error('请完善您的数据！')
                        return false
                    }
                })
            })
        },
        _addObject(obj) {
            this.setLoading(true)
            addReport({
                data: Object.assign({}, obj),
                success: data => {
                    this.submitBtn = false
                    this.$message.success('保存成功！')
                    this.setLoading(false)
                    this.$router.push({path: '/cms/report/reportList', query: {refresh: '1'}})
                },
                error: data => {
                    this.submitBtn = false
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
            this.submitBtn = false
        },
        _editObject(obj) {
            this.setLoading(true)
            editReport({
                data: Object.assign({}, obj),
                success: data => {
                    this.submitBtn = false
                    this.$message.success('保存成功！')
                    this.setLoading(false)
                    this.$router.push({path: '/cms/report/reportList', query: {refresh: '0'}})
                },
                error: data => {
                    this.submitBtn = false
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
            this.submitBtn = false
        },
        _getShopGroupList () {
            getShopGroupList({
                data: {},
                success: data => {
                    this.shopGroupList = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getReportIndustryList() {
            getReportIndustryList({
                data: {},
                success: data => {
                    this.industryList = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getReportView({
                data: {
                    innerid: this.item.innerid
                },
                success: data => {
                    if (data.data.checkView && data.data.checkView !== '') {
                        data.data.checkView = formatCheckView(JSON.parse(data.data.checkView), this.$refs.promotionMsg.item.checkView)
                    }
                    data.data.nodes = data.data.nodes.split(',')
                    data.data.imageinfo = JSON.parse(data.data.imageinfo)
                    data.data.pdfinfo = JSON.parse(data.data.pdfinfo)
                    if (data.data.divisionids && data.data.divisionids !== '') {
                        data.data.divisionids = JSON.parse(data.data.divisionids)
                    } else {
                        data.data.divisionids = []
                    }
                    if (data.data.isdownload) {
                        data.data.isdownload = true
                    }
                    if (data.data.ispreview === '0') {
                        data.data.previewpages = ''
                    }
                    this.item = data.data
                    this.item.isplatform = this.item.isplatform === 1
                    this.item.ispublic = this.item.ispublic === 1
                    this.$refs.uEditor.init(this.item.repintro)
                    this.$refs.promotionMsg.setItem(this.item)
                    this.$refs.coverfile.setImage(this.item.imageinfo.furl)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        delPdf() {
            this.item.pdfinfo = {
                bucket: '',
                fname: '',
                fsize: '',
                key: '',
                mimeType: '',
                furl: ''
            }
        },
        // 前往商品分组
        goGoodsGroup() {
            let goPath = window.location.origin + '/shopMgt/goods/goodsGroup'
            window.open(goPath)
        },
        cancel() {
            this.$router.push('/cms/report/reportList')
        },
        ...mapActions([
            'setLoading'
        ]),
        changeWay(type) {
            this.feetype = String(type)
        }
    },
    filters: {},
    watch: {
        'feetype': {
            handler(newFeetype, oldFeetype) {
                this._getShopGroupList()
            }
        },
        'item.ispreview': {
            handler(newFeetype, oldFeetype) {
                if (newFeetype === '1' && this.feetype === 1) {
                    // this.$refs.promotionMsg.$refs.share.value = true
                    this.$refs.promotionMsg.item.checkView.share.status = true
                } else if (newFeetype === '0') {

                }
            }
        },
        deep: true,
        immediate: true
    },
    computed: {
        fsize () {
            return function(size) {
                return computeFileSize(size)
            }
        },
        ...mapGetters([
            'loading',
            'user',
            'domain'
        ])
    },
    components: {
        Upload,
        UploadFile,
        UEditor,
        PromotionMsg,
        // Gallery,
        ScrollBox,
        ShalfSetting
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/mixin";
.reportEdit {
    // .upload-file{
    //     width: 800px;
    // }
    .message{
        margin-bottom: 20px;
    }
    .upload-image{
        .el-form-item__label::after{
            content: '*';
            color: #F56C6C;
        }
        .el-form-item__content{
            @include flexBox(space-between);
            .el-form-item__error{
                padding-top: 3px;
            }
        }
    }
    .headImage .avatar-uploader{
        box-sizing: border-box;
        width: 320px;
        height: 180px;
    }
    .el-upload__tip{
        color: $tcolor-lightgrey;
        align-self: flex-end;
        margin-left: 20px;
        flex-grow: 1;
    }
    .ispreview-tip{
        width: 800px;
        border-top: 1px solid $line;
        padding-top: 10px;
        color: $tcolor-grey;
        div{
            @include flexBox(flex-start);
        }
    }
    .el-radio-group{
        position: relative;
        top: -8px;
    }
    .uploadFileBox{
        .pdfMsg{
            width: 264px;
            height: 40px;
            line-height: 40px;
            box-sizing: border-box;
            padding: 0 20px;
            background: #DCDFE6;
            display: flex;
            justify-content: space-around;
            margin-bottom: 10px;
            .delPdf{
                color: #409EFF;
                cursor: pointer;
            }
            .fname{
                width: 100px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: inline-block;
            }
        }
        .upload-pdf{
            @include flexBox(flex-start);
        }
    }
    .reportname,.reportLabel,.reportCatalog{
        .el-form-item__content{
            width: 800px;
            .el-textarea__inner{
                resize: none;
                height: 228px;
            }
        }
    }
    .zjmemtype {
        .el-form-item__content{
            display: flex;
            align-items: center;
            height: 28px;
            .el-radio-group {
                top: 0;
            }
        }
    }
    .uploadFileBox{
        .el-input{
            width: 680px;
        }
    }
    .form-4{
        .el-form-item__label{
            line-height: inherit;
        }
        .el-radio{
            width: 100%;
            margin-bottom: 22px;
        }
        .el-input--mini{
            margin: 0 10px;
        }
        .el-radio .el-input, .el-radio .el-input__inner{
            width: 200px;
        }
    }
    .form-5{
        .el-form-item__label{
            line-height: inherit;
        }
        .el-radio{
            width: 100%;
            margin-bottom: 22px;
        }
        .el-input--mini{
            margin: 0 10px;
        }
        .el-radio .el-input, .el-radio .el-input__inner{
            width: 60px;
        }
        .el-form-item__content{
            .el-form-item__error{
                position: relative;
                top: -160px;
                left: 200px;
                width: 100px;
            }
        }
    }
    .group{
        @include flexBox(flex-start);
    }
    .commodityGroup{
        .el-select{
            width: 368px;
        }
        .el-button{
            min-width: 0;
            margin: 0 10px;
        }
        .groupTips{
            color: #909399;
        }
    }
}
</style>
